import { useContext } from 'react';

import { WWContext, type WWContextValue } from '../components/WWContext';
import expandFonts from './expandFonts';

import type { Theme } from '@emotion/react';

function extractThemeStyles(themeStyles: unknown): Theme | undefined {
  return (
    (themeStyles as { styles: Theme }[] | undefined)?.[0]?.styles ?? undefined
  );
}

function useThemeStyles(themeOverride?: string | undefined): Theme {
  const { data } = useContext<WWContextValue>(WWContext);

  if (data && data.weddingWebsiteResult) {
    const { theme } = data.weddingWebsiteResult;

    let themeStyles: Theme | undefined;

    if (themeOverride) {
      try {
        themeStyles = JSON.parse(themeOverride);
      } catch {
        themeStyles = extractThemeStyles(theme?.themeStyles);
      }
    } else if (theme) {
      themeStyles = extractThemeStyles(theme?.themeStyles);
    }

    if (!themeStyles) {
      return {} as Theme;
    }

    themeStyles = expandFonts(themeStyles);

    return themeStyles;
  }

  return {} as Theme;
}

export default useThemeStyles;
